"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRecalled = void 0;
const isRecalled = (consumable) => consumable.state.recalled;
exports.isRecalled = isRecalled;
//# sourceMappingURL=recallable.js.map